import { render, staticRenderFns } from "./OrdersTable.vue?vue&type=template&id=2c412788&scoped=true"
import script from "./OrdersTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrdersTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OrdersTable.vue?vue&type=style&index=0&id=2c412788&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c412788",
  null
  
)

export default component.exports